import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tag-select" }
const _hoisted_2 = {
  key: 0,
  class: "select-header"
}
const _hoisted_3 = { class: "tag-option" }
const _hoisted_4 = { class: "tag-category" }

import { ref, onMounted, watch } from 'vue';
import { ElMessage, FormInstance } from 'element-plus';
import { Plus } from '@element-plus/icons-vue';
import type { Tag } from '@/types/tag';
import { TAG_CATEGORIES } from '@/types/tag';
import tagApi from '@/services/tagApi';


export default /*@__PURE__*/_defineComponent({
  __name: 'TagSelect',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// 状态变量
const loading = ref(false);
const tags = ref<Tag[]>([]);
const filteredTags = ref<Tag[]>([]);
const dialogVisible = ref(false);
const formRef = ref<FormInstance>();

// 表单数据
const form = ref({
  name: '',
  color: '#409EFF',
  category: ''
});

// 表单校验规则
const rules = {
  name: [{ required: true, message: '请输入标签名称' }],
  color: [{ required: true, message: '请选择标签颜色' }],
  category: [{ required: true, message: '请选择标签分类' }]
};

// 选中的标签
const selectedTags = ref<number[]>([]);

// 监听选中标签变化
watch(selectedTags, (newValue) => {
  emit('update:modelValue', newValue);
});

// 监听外部值变化
watch(() => props.modelValue, (newValue) => {
  selectedTags.value = newValue;
});

// 加载标签列表
const loadTags = async () => {
  try {
    loading.value = true;
    const response = await tagApi.getTags();
    tags.value = response.content;
    filteredTags.value = response.content;
  } catch (error) {
    console.error('加载标签列表失败:', error);
    ElMessage.error('加载标签列表失败');
  } finally {
    loading.value = false;
  }
};

// 搜索标签
const handleSearch = async (query: string) => {
  if (!query) {
    filteredTags.value = tags.value;
    return;
  }

  try {
    loading.value = true;
    const response = await tagApi.searchTags(query);
    filteredTags.value = response.content;
  } catch (error) {
    console.error('搜索标签失败:', error);
  } finally {
    loading.value = false;
  }
};

// 处理下拉框显示状态变化
const handleVisibleChange = (visible: boolean) => {
  if (visible) {
    loadTags();
  }
};

// 显示添加标签对话框
const showAddTagDialog = () => {
  form.value = {
    name: '',
    color: '#409EFF',
    category: ''
  };
  dialogVisible.value = true;
};

// 提交添加标签表单
const handleSubmit = async () => {
  if (!formRef.value) return;

  await formRef.value.validate(async (valid) => {
    if (valid) {
      try {
        const newTag = await tagApi.addTag(form.value);
        tags.value.push(newTag);
        filteredTags.value = tags.value;
        selectedTags.value = [...selectedTags.value, newTag.id];
        dialogVisible.value = false;
        ElMessage.success('标签添加成功');
      } catch (error) {
        console.error('添加标签失败:', error);
        ElMessage.error('添加标签失败');
      }
    }
  });
};

// 初始化
onMounted(() => {
  selectedTags.value = props.modelValue;
});

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_color_picker = _resolveComponent("el-color-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_select, {
      modelValue: selectedTags.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedTags).value = $event)),
      multiple: "",
      filterable: "",
      remote: "",
      "remote-method": handleSearch,
      loading: loading.value,
      placeholder: "请选择标签",
      onVisibleChange: handleVisibleChange,
      class: "tag-select-input"
    }, {
      default: _withCtx(() => [
        (filteredTags.value.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_el_button, {
                type: "primary",
                link: "",
                onClick: _withModifiers(showAddTagDialog, ["stop"])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Plus))
                    ]),
                    _: 1
                  }),
                  _cache[6] || (_cache[6] = _createTextVNode(" 创建新标签 "))
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredTags.value, (tag) => {
          return (_openBlock(), _createBlock(_component_el_option, {
            key: tag.id,
            label: tag.name,
            value: tag.id
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_el_tag, {
                  style: _normalizeStyle({ backgroundColor: tag.color + '20', color: tag.color }),
                  effect: "plain"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(tag.name), 1)
                  ]),
                  _: 2
                }, 1032, ["style"]),
                _createElementVNode("span", _hoisted_4, _toDisplayString(tag.category), 1)
              ])
            ]),
            _: 2
          }, 1032, ["label", "value"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue", "loading"]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dialogVisible).value = $event)),
      title: "添加标签",
      width: "400px",
      "close-on-click-modal": false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (dialogVisible.value = false))
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [
            _createTextVNode("取消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleSubmit
        }, {
          default: _withCtx(() => _cache[8] || (_cache[8] = [
            _createTextVNode("确定")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: form.value,
          rules: rules,
          "label-width": "80px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "标签名称",
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.value.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.name) = $event)),
                  placeholder: "请输入标签名称"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "标签颜色",
              prop: "color"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_color_picker, {
                  modelValue: form.value.color,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.color) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "标签分类",
              prop: "category"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: form.value.category,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.category) = $event)),
                  placeholder: "请选择标签分类"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(TAG_CATEGORIES), (category) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: category.value,
                        label: category.label,
                        value: category.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})